<!-- Container -->
<div class="kt-container-fixed flex items-center justify-between lg:gap-4" id="headerContainer">
	<app-logo></app-logo>
	<!-- Topbar -->
	<div class="flex items-center gap-2.5">
		<app-topbar-notification-dropdown></app-topbar-notification-dropdown>
		<app-topbar-chat></app-topbar-chat>
		<app-topbar-user-dropdown></app-topbar-user-dropdown>
	</div>
	<!-- End of Topbar -->
</div>
<!-- End of Container -->